import React, {Component} from 'react';
import {Button, Modal, ModalHeader} from 'reactstrap';
import {FaIcon} from "../FaIcon";
import {InviteCRMUserForm} from "./InviteCRMUserForm";

export class InviteCRMUserModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);
        this.afterSubmit = this.afterSubmit.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSubmit() {
        this.toggle();
        this.props.onUserInvited();
    }

    render() {
        return (
            <div>
                <Button className="btn -alt" onClick={this.toggle}>
                    <FaIcon iconName="user-plus"/>
                    Invitar Usuario
                </Button>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}><FaIcon iconName="user-plus"/>Invite new user</ModalHeader>
                    <InviteCRMUserForm clientId={this.props.clientId} afterSubmit={this.afterSubmit}/>
                </Modal>
            </div>
        );
    }
}

